import Service, { getCallApiFunction } from '../service'
type ParamsType = {
  data: {
    roomId: string
  }
}
type ResponseType = {
  isSuccess: boolean
  roomId: string[]
}
class AddFavoriteRoomApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.config = {
      url: '/v1/livemall/member/favorite',
      method: 'POST',
      data: params.data,
    }
  }
}
export const addFavoriteRoom = async (params: ParamsType): Promise<ResponseType> => getCallApiFunction(new AddFavoriteRoomApi(params))
